import React from 'react';

function Footer()
{
    return(
      <>
        <footer className="footer">
          <span>Copyright &copy; { new Date().getFullYear() } Just a Date</span>
        </footer>
      </>
    )
}
export default React.memo(Footer)
